<template>
    <v-card scrollable>
        <v-img
                :src="event.imgurl"
                aspect-ratio="2.75"
        >
            <v-container fill-height v-if="event.active">
                <v-row
                        align-content-center
                        mx-auto
                        wrap
                >
                    <v-col class="text-center">

                    </v-col>
                </v-row>
            </v-container>
        </v-img>
        <v-card-title>
            {{event.name}}
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <!--<v-flex xs3 class="text-xs-center">-->
                    <!--<div class="title blue&#45;&#45;text">{{month[new Date(event.eventtimes[0].date).getMonth()]}}</div>-->
                    <!--<div class="display-1">{{(event.eventtimes[0].date).split('-')[2]}}</div>-->
                <!--</v-flex>-->
                <v-flex xs9>
                    {{event.caption || event.description}}
                </v-flex>
                <v-flex xs12 class="text-xs-center my-2">
                    <div v-for="s in skus" :key="s.is" style="background-color: #ddd;">
                        ${{s.price/100}} - {{s.attributes.name}}
                    </div>
                </v-flex>
                <v-flex xs12 py-2>
                    <v-icon class="pr-2">fas fa-map-marker-alt</v-icon> {{event.location}}
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <hr class="my-2" />
                    <div class="text-xs-center body-1 font-weight-light" v-for="t in event.eventtimes" :key="t.id+'-'+t.time">
                        {{t.dt}} - {{t.t}} - {{t.duration/60}} Hr{{(t.duration/60>1)?'s':''}}
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn text @click="$emit('close')">Close</v-btn>
            <v-spacer></v-spacer>
            <a :href="event.external_registration_link" target="_blank" v-if="event.external_registration_link" >
                <v-btn text >
                    Register <v-icon class="pl-2" small>mdi-thumbs-up</v-icon>
                </v-btn>
            </a>
            <v-btn text v-else-if="(!loggedIn && !event.external_registration_link)"  :to="'/auth/signin?register='+event.id" >Sign in to register</v-btn>
            <v-btn text v-else-if="event.stripeId && event.active && loggedIn" @click="$emit('register'),$emit('close')" >
                Register <v-icon class="pl-2" small>mdi-thumbs-up</v-icon>
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="teamlistdialog">

        </v-dialog>
    </v-card>
</template>

<script>
    export default {
        props:['event','skus'],
        components: {},
        name: "EventCard",
        data() {
            return {
                month:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                d:'',
                teamlistdialog:false
            }
        },
        computed:{
          loggedIn(){
            return this.$store.getters['cognito/isLoggedIn'];
          },
        },
        mounted() {

        },
        methods: {
        }
    }
</script>

<style scoped>
    a{
        text-decoration: none;
    }
</style>